"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_virtualized_1 = require("react-virtualized");
var props_1 = require("../../context/props");
var InfiniteLoaderVirtualizes = react_virtualized_1.InfiniteLoader;
var infiniteLoader = function (Component) { return function (_a) {
    var props = __rest(_a, []);
    var isInfiniteScrolling = props.isInfiniteScrolling, hasNextPage = props.hasNextPage, loadNextPage = props.loadNextPage, otherProps = __rest(props, ["isInfiniteScrolling", "hasNextPage", "loadNextPage"]);
    var data = props.data;
    var isLoading = (0, props_1.usePropsContext)().isLoading;
    if (!isInfiniteScrolling)
        return react_1.default.createElement(Component, __assign({}, otherProps));
    var getRowsCount = (0, react_1.useCallback)(function () { return (data ? data.length : 0); }, [data]);
    var isRowLoaded = (0, react_1.useCallback)(function (_a) {
        var index = _a.index;
        return (!hasNextPage || index < getRowsCount());
    }, [getRowsCount, hasNextPage]);
    var loadMoreRows = (0, react_1.useMemo)(function () { return (isLoading
        ? function () { return new Promise(function () { }); } : loadNextPage); }, [isLoading, loadNextPage]);
    var rowCount = (0, react_1.useMemo)(function () { return (hasNextPage
        ? getRowsCount() + 1 : getRowsCount()); }, [hasNextPage, getRowsCount]);
    return (react_1.default.createElement(InfiniteLoaderVirtualizes, { isRowLoaded: isRowLoaded, loadMoreRows: loadMoreRows, rowCount: rowCount }, function (_a) {
        var onRowsRendered = _a.onRowsRendered, registerChild = _a.registerChild;
        return (react_1.default.createElement(Component, __assign({}, otherProps, { onRowsRendered: onRowsRendered, registerChild: registerChild })));
    }));
}; };
exports.default = infiniteLoader;
